import { useMutation, UseMutationResult } from "react-query"
import Settings from "utils/CarrotConfig"
import CarrotClient from "lib/carrot-api"
import ResponseError from "utils/ResponseError"
import { reportError } from "utils/ErrorReporting"
import { RecommendationsDiff } from "types/RecommendationsDiff"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)

type AdminChangesPayload = {
  employeeId: number
  carrotPlanId: number
  journeyId: number | null
  journeyStageId: number | null
  diff: RecommendationsDiff
}

export function useReportRecommendationsAdminChanges(): UseMutationResult<void, ResponseError, AdminChangesPayload> {
  return useMutation<void, ResponseError, AdminChangesPayload>(
    ({ employeeId, carrotPlanId, journeyId, journeyStageId, diff }) =>
      client.reportCarrotPlanRecommendationsAdminChanges(employeeId, carrotPlanId, journeyId, journeyStageId, diff),
    {
      retry: false,
      onError: reportError
    }
  )
}
